import {
  SPLIT_FEATURES_REQUEST_SUCCESS,
  SPLIT_FEATURES_REQUEST_FAILED,
  SplitState,
  SplitActionsTypes,
} from '../types/split';

const initialState: SplitState = {
  loaded: false,
  features: {},
};

export default function SplitReducer(
  state = initialState,
  action: SplitActionsTypes,
): SplitState {
  switch (action.type) {
    case SPLIT_FEATURES_REQUEST_SUCCESS: {
      return {
        ...state,
        features: action.payload,
        loaded: true,
      };
    }

    case SPLIT_FEATURES_REQUEST_FAILED: {
      return {
        ...state,
        features: {},
        loaded: false,
      };
    }

    default: {
      return state;
    }
  }
}
